/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaUiASkip2BackIcon16Light } from './MediaUiASkip2BackIcon16Light';
import { MediaUiASkip2BackIcon16Regular } from './MediaUiASkip2BackIcon16Regular';
import { MediaUiASkip2BackIcon16Solid } from './MediaUiASkip2BackIcon16Solid';
import { MediaUiASkip2BackIcon20Light } from './MediaUiASkip2BackIcon20Light';
import { MediaUiASkip2BackIcon20Regular } from './MediaUiASkip2BackIcon20Regular';
import { MediaUiASkip2BackIcon20Solid } from './MediaUiASkip2BackIcon20Solid';
import { MediaUiASkip2BackIcon24Regular } from './MediaUiASkip2BackIcon24Regular';
import { MediaUiASkip2BackIcon24Solid } from './MediaUiASkip2BackIcon24Solid';
import { MediaUiASkip2BackIcon32Regular } from './MediaUiASkip2BackIcon32Regular';
import { MediaUiASkip2BackIcon64Regular } from './MediaUiASkip2BackIcon64Regular';
var sizes = {
    16: {
        light: MediaUiASkip2BackIcon16Light,
        regular: MediaUiASkip2BackIcon16Regular,
        solid: MediaUiASkip2BackIcon16Solid,
    },
    20: {
        light: MediaUiASkip2BackIcon20Light,
        regular: MediaUiASkip2BackIcon20Regular,
        solid: MediaUiASkip2BackIcon20Solid,
    },
    24: {
        regular: MediaUiASkip2BackIcon24Regular,
        solid: MediaUiASkip2BackIcon24Solid,
    },
    32: {
        regular: MediaUiASkip2BackIcon32Regular,
    },
    64: {
        regular: MediaUiASkip2BackIcon64Regular,
    },
};
export var MediaUiASkip2BackIcon = forwardRef('MediaUiASkip2BackIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
